export default __webpack_public_path__ + "static/media/displayLg.ee0cc68a.png";